import { api } from "@/lib/api";

export const hrApi = {
  meta: () => api.get("/hr/meta").then((r) => r.data),
  stats: () => api.get("/hr/stats").then((r) => r.data),
  activeEmployees: () => api.get("/hr/employees/active").then((r) => r.data),
  // employees
  listEmployees: (params) => api.get("/hr/employees", { params }).then((r) => r.data),
  getEmployee: (id) => api.get(`/hr/employees/${id}`).then((r) => r.data),
  createEmployee: (body) => api.post("/hr/employees", body).then((r) => r.data),
  updateEmployee: (id, body) => api.put(`/hr/employees/${id}`, body).then((r) => r.data),
  setEmpStatus: (id, status) => api.patch(`/hr/employees/${id}/status`, { status }).then((r) => r.data),
  // attendance
  listAttendance: (params) => api.get("/hr/attendance", { params }).then((r) => r.data),
  markAttendance: (body) => api.post("/hr/attendance", body).then((r) => r.data),
  bulkAttendance: (body) => api.post("/hr/attendance/bulk", body).then((r) => r.data),
  // leave
  listLeaves: (params) => api.get("/hr/leaves", { params }).then((r) => r.data),
  applyLeave: (body) => api.post("/hr/leaves", body).then((r) => r.data),
  decideLeave: (id, decision, note) => api.patch(`/hr/leaves/${id}/decision`, { decision, note }).then((r) => r.data),
  // payroll
  payrollRuns: () => api.get("/hr/payroll/runs").then((r) => r.data),
  listPayslips: (month) => api.get("/hr/payroll", { params: { month } }).then((r) => r.data),
  runPayroll: (month, ot_rate) => api.post("/hr/payroll/run", { month, ot_rate }).then((r) => r.data),
};

export const EMP_STATUS_STYLE = {
  Active: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Inactive: "bg-slate-100 text-slate-500",
};

export const ATT_STATUS_STYLE = {
  Present: "bg-emerald-50 text-emerald-700",
  Absent: "bg-rose-50 text-rose-700",
  "Half Day": "bg-amber-50 text-amber-700",
  Leave: "bg-blue-50 text-blue-700",
  "Week Off": "bg-slate-100 text-slate-500",
  Holiday: "bg-violet-50 text-violet-700",
};

export const LEAVE_STATUS_STYLE = {
  Pending: "bg-amber-50 text-amber-700 border border-amber-200",
  Approved: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Rejected: "bg-rose-50 text-rose-700 border border-rose-200",
  Cancelled: "bg-slate-100 text-slate-500",
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
